import React, { useMemo } from "react";
import { put } from "aws-amplify/api";
import { Modal, Button } from "react-bootstrap";
import SLMPropertyIntegrationsList from "containers/slm/shared/SLMPropertyIntegrationsList";
import { createElementIdFactory } from "utils/elementIds";

export default function SLMPropertyIntegrationsModal({
  show,
  onClose,
  isAuthenticated,
  user,
  updateTableState,
  filter,
  saveForm,
  data,
  saveRecord,
  deleteRecord,
  validateRelatedRecord,
  streetOptions,
  acceptIntegration,
  rejectIntegration,
  context,
  ctx,
}) {
  const createId = useMemo(() => createElementIdFactory("slm-property-integrations-modal"), []);

  const deleteAll = async () => {
    if ((data || []).length === 0) {
      return;
    }

    const confirmed = window.confirm("Are you sure you want to delete all Equivalent Properties?");
    if (!confirmed) {
      return;
    }

    const localData = [...data].map((item) => ({
      ...item,
      archived_date: new Date().toISOString(),
    }));

    const declaredContext = (context || ctx || "").toLowerCase();
    const leaseId = filter?.leaseid ?? filter?.lease_id ?? null;
    const saleId = filter?.saleid ?? filter?.sale_id ?? null;
    const activeContext =
      declaredContext === "slmlease" || declaredContext === "slmsale"
        ? declaredContext
        : saleId
          ? "slmsale"
          : leaseId
            ? "slmlease"
            : "";

    const endpoint =
      activeContext === "slmsale" && saleId
        ? `/slmsales/${saleId}/integrations_bulk/null`
        : leaseId
          ? `/slmleases/${leaseId}/integrations_bulk/null`
          : null;

    if (!endpoint) {
      updateTableState?.([], "integrations");
      return;
    }

    const response = await put({
      apiName: "colin",
      path: endpoint,
      options: {
        body: localData,
      },
    }).response;

    try {
      await response.body.json();
      updateTableState?.([], "integrations");
    } catch (error) {
      window.alert(error + ". Please refresh the page (F5) to try again.");
    }
  };

  return (
    <Modal show={show} onHide={onClose} dialogClassName="slm-title-details-modal-wide" size="xl" id={createId("modal")}>
      <Modal.Header closeButton>
        <Modal.Title id={createId("title")}>CoreLogic Equivalent Properties</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-2 px-md-3" style={{ overflowX: "auto" }}>
        <div className="text-right mb-1">
          <Button id={createId("action", "delete-all", "button")} type="button" size="sm" variant="danger" onClick={deleteAll}>
            Delete All
          </Button>
        </div>
        <SLMPropertyIntegrationsList
          filter={filter}
          isAuthenticated={isAuthenticated}
          isLoading={false}
          controlType="table"
          saveForm={saveForm}
          user={user}
          data={data}
          updateTableState={updateTableState}
          saveRecord={saveRecord}
          deleteRecord={deleteRecord}
          validateRelatedRecord={validateRelatedRecord}
          streetOptions={streetOptions}
          acceptIntegration={acceptIntegration}
          rejectIntegration={rejectIntegration}
          context={context}
          ctx={ctx}
        />
      </Modal.Body>
    </Modal>
  );
}
